<template>
    <div class="home">
        <img src="../../assets/images/homePng.png" alt="">
        <!--<div class="home_left">-->
            <!--<div class="home_left_top" v-if="wddb">-->
                <!--<div class="home_wddb">-->
                    <!--<p>我的待办</p>-->
                    <!--<div class="home_wddb_list">-->
                        <!--<div class="home_wddb_name">-->
                            <!--<div class="home_wddb_name_icon">-->
                                <!--<img src="../../assets/images/ico_12345.png" alt="">-->
                                <!--<span>接诉即办</span>-->
                            <!--</div>-->
                            <!--<img src="../../assets/images/arrow-right-s-line.png" alt="">-->
                        <!--</div>-->
                        <!--<div class="home_wddb_overtime">-->
                            <!--<div class="home_wddb_overtime_true">-->
                                <!--<div class="home_wddb_overtime_num">-->
                                    <!--{{wddb.jsjb.yjcs}}-->
                                <!--</div>-->
                                <!--<span>已经超时</span>-->
                            <!--</div>-->
                            <!--<div class="home_wddb_overtime_false">-->
                                <!--<div class="home_wddb_overtime_num">-->
                                    <!--{{wddb.jsjb.jjcs}}-->
                                <!--</div>-->
                                <!--<span>即将超时</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="home_wddb_dqs">-->
                            <!--<div class="home_wddb_dqs_num">-->
                                <!--{{wddb.jsjb.dqs}}-->
                            <!--</div>-->
                            <!--<div class="home_wddb_dqs_dscript">-->
                                <!--<img src="../../assets/images/jsjb_dqs.png" alt="">-->
                                <!--<span>待签收</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="home_wddb_dqs">-->
                            <!--<div class="home_wddb_dqs_num">-->
                                <!--{{wddb.jsjb.dcl}}-->
                            <!--</div>-->
                            <!--<div class="home_wddb_dqs_dscript">-->
                                <!--<img src="../../assets/images/jsjb_dcl.png" alt="">-->
                                <!--<span>待处理</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="home_wddb_list">-->
                        <!--<div class="home_wddb_name">-->
                            <!--<div class="home_wddb_name_icon">-->
                                <!--<img src="../../assets/images/ico_wsjb.png" alt="">-->
                                <!--<span>未诉先办</span>-->
                            <!--</div>-->
                            <!--<img src="../../assets/images/arrow-right-s-line.png" alt="">-->
                        <!--</div>-->
                        <!--<div class="home_wddb_overtime">-->
                            <!--<div class="home_wddb_overtime_true">-->
                                <!--<div class="home_wddb_overtime_num">-->
                                    <!--{{wddb.wgsj.yjcs}}-->
                                <!--</div>-->
                                <!--<span>已经超时</span>-->
                            <!--</div>-->
                            <!--<div class="home_wddb_overtime_false">-->
                                <!--<div class="home_wddb_overtime_num">-->
                                    <!--{{wddb.wgsj.jjcs}}-->
                                <!--</div>-->
                                <!--<span>即将超时</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="home_wddb_dqs">-->
                            <!--<div class="home_wddb_dqs_num">-->
                                <!--{{wddb.wgsj.dqs}}-->
                            <!--</div>-->
                            <!--<div class="home_wddb_dqs_dscript">-->
                                <!--<img src="../../assets/images/jsjb_dqs.png" alt="">-->
                                <!--<span>待签收</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="home_wddb_dqs">-->
                            <!--<div class="home_wddb_dqs_num">-->
                                <!--{{wddb.wgsj.dcl}}-->
                            <!--</div>-->
                            <!--<div class="home_wddb_dqs_dscript">-->
                                <!--<img src="../../assets/images/jsjb_dcl.png" alt="">-->
                                <!--<span>待处理</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="home_jrgdzl">-->
                    <!--<p>今日工单总量</p>-->
                    <!--<div class="home_jrgdzl_list">-->
                        <!--<img src="../../assets/images/ico_xgd.png" alt="">-->
                        <!--<p>新工单</p>-->
                        <!--<span>{{wddb.xgd}}</span>-->
                    <!--</div>-->
                    <!--<div class="home_jrgdzl_list">-->
                        <!--<img src="../../assets/images/ico_dsh.png" alt="">-->
                        <!--<p>待审核</p>-->
                        <!--<span>{{wddb.dsh}}</span>-->
                    <!--</div>-->
                    <!--<div class="home_jrgdzl_list">-->
                        <!--<img src="../../assets/images/ico_th.png" alt="">-->
                        <!--<p>退回工单</p>-->
                        <!--<span>{{wddb.thgd}}</span>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="home_left_bottom">-->
                <!--<div class="home_cygn">-->
                    <!--<p>常用功能</p>-->
                    <!--<div class="home_cygn_main">-->
                        <!--<div class="home_cygn_list">-->
                            <!--<img src="../../assets/images/ico_tz.png" alt="">-->
                            <!--<p>通知</p>-->
                        <!--</div>-->
                        <!--<div class="home_cygn_list">-->
                            <!--<img src="../../assets/images/ico_zsk.png" alt="">-->
                            <!--<p>知识库</p>-->
                        <!--</div>-->
                        <!--<div class="home_cygn_list">-->
                            <!--<img src="../../assets/images/ico_txl.png" alt="">-->
                            <!--<p>通讯录</p>-->
                        <!--</div>-->
                        <!--<div class="home_cygn_list">-->
                            <!--<img src="../../assets/images/ico_sc.png" alt="">-->
                            <!--<p>收藏</p>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="home_kh">-->
                    <!--<div class="home_title">-->
                        <!--<p>本考核周期内考核排名</p>-->
                        <!--<img src="../../assets/images/ico_more.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="home_table">-->
                        <!--<el-table :data="tableData">-->
                            <!--<el-table-column prop="date" label="承办单位"  align="center" min-width="25%" />-->
                            <!--<el-table-column prop="name" label="总量"  align="center" min-width="25%" />-->
                            <!--<el-table-column prop="address" label="综合评分"  align="center" min-width="25%" />-->
                            <!--<el-table-column prop="address" label="排名"  align="center" min-width="25%">-->
                                <!--<template #default="scope">-->
                                    <!--<div class="home_table_rank rankFirst">-->
                                        <!--1-->
                                    <!--</div>-->
                                    <!--<div class="home_table_rank rankSecond">-->
                                        <!--2-->
                                    <!--</div>-->
                                    <!--<div class="home_table_rank rankThird">-->
                                        <!--3-->
                                    <!--</div>-->
                                    <!--<div class="home_table_rank">-->
                                        <!--4-->
                                    <!--</div>-->
                                <!--</template>-->
                            <!--</el-table-column>-->
                        <!--</el-table>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="home_right">-->
            <!--<div class="home_title">-->
                <!--<p>通知</p>-->
                <!--<img src="../../assets/images/ico_more.png" alt="">-->
            <!--</div>-->
            <!--<div class="home_right_main">-->
                <!--&lt;!&ndash;<div class="home_right_list">&ndash;&gt;-->
                    <!--&lt;!&ndash;<img src="../../assets/images/xxtx.png" alt="">&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>政策法规标题</span>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="home_right_list">&ndash;&gt;-->
                    <!--&lt;!&ndash;<img src="../../assets/images/xxtx.png" alt="">&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>政策法规标题</span>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="home_right_list">&ndash;&gt;-->
                    <!--&lt;!&ndash;<img src="../../assets/images/xxtx.png" alt="">&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>政策法规标题</span>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { ref,onMounted,getCurrentInstance} from 'vue';
    export default {
        name: "Home",
        components: {

        },
        setup(){
            const {proxy} = getCurrentInstance();
            const tableData = ref([]);
            //我的待办
            let wddb = ref()
            onMounted(()=>{
                // proxy.$axios.get("/jgfast/wgsj/selIndexCount").then((res) => {
                //     wddb.value = res.data
                // })
            })
            return{
                tableData,
                wddb
            }
        }
    }
</script>

<style scoped>

</style>
